// Sprint 8 — Helper de display em MAIÚSCULAS (banco em minúsculas / front em CAIXA ALTA)
// Centraliza labels de status, propriedade e tipo_cliente para evitar string scattering.

export const STATUS_EQUIP_LABEL = {
  disponivel: "DISPONÍVEL",
  reservado: "RESERVADO",
  locado: "LOCADO",
  com_cliente: "COM CLIENTE",
  em_atendimento: "EM ATENDIMENTO",
  na_oficina: "NA OFICINA",
  oficina: "NA OFICINA",
  em_rota: "EM ROTA",
  em_transito: "EM TRÂNSITO",
  devolvido: "DEVOLVIDO",
  extraviado: "EXTRAVIADO",
  baixado: "BAIXADO",
};

export const STATUS_EQUIP_BADGE = {
  disponivel: "bg-emerald-100 text-emerald-700",
  reservado: "bg-sky-100 text-sky-700",
  locado: "bg-blue-100 text-blue-700",
  com_cliente: "bg-blue-100 text-blue-700",
  em_atendimento: "bg-amber-100 text-amber-700",
  na_oficina: "bg-orange-100 text-orange-700",
  oficina: "bg-orange-100 text-orange-700",
  em_rota: "bg-cyan-100 text-cyan-700",
  em_transito: "bg-purple-100 text-purple-700",
  devolvido: "bg-zinc-100 text-zinc-700",
  extraviado: "bg-red-100 text-red-700",
  baixado: "bg-zinc-200 text-zinc-700",
};

export const PROPRIEDADE_LABEL = {
  jungheinrich: "JUNGHEINRICH",
  logman: "LOGMAN",
  locativo: "LOCATIVO",
};

export const TIPO_CLIENTE_LABEL = {
  helpdesk: "HELPDESK",
  locativo: "LOCATIVO",
  ambos: "AMBOS",
};

export const PERFIL_SPRINT8_LABEL = {
  ADMIN: "ADMIN",
  GERENTE: "GERENTE",
  SUPERVISOR: "SUPERVISOR",
  TECNICO: "TÉCNICO",
  ATENDIMENTO: "ATENDIMENTO",
  FINANCEIRO: "FINANCEIRO",
};

export function statusEquipLabel(s) {
  return STATUS_EQUIP_LABEL[s] || (s ? String(s).toUpperCase() : "—");
}

export function propriedadeLabel(p) {
  return PROPRIEDADE_LABEL[p] || (p ? String(p).toUpperCase() : "—");
}

export function tipoClienteLabel(t) {
  return TIPO_CLIENTE_LABEL[t] || (t ? String(t).toUpperCase() : "—");
}
